import { render, staticRenderFns } from "./NotificationPanelItem.vue?vue&type=template&id=9552abce&"
import script from "./NotificationPanelItem.vue?vue&type=script&lang=js&"
export * from "./NotificationPanelItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9552abce')) {
      api.createRecord('9552abce', component.options)
    } else {
      api.reload('9552abce', component.options)
    }
    module.hot.accept("./NotificationPanelItem.vue?vue&type=template&id=9552abce&", function () {
      api.rerender('9552abce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/notifications/components/NotificationPanelItem.vue"
export default component.exports